import { fetchAllRegions } from "@/helpers/regions";

export default {
  async fetchAllRegions({ commit }) {
    const regions = await fetchAllRegions();
    return commit("setRegions", regions);
  },
};
